import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
/**
 * Renders an `Input` component that is hidden and holds a serialized (JSON stringified) version of the provided value.
 * This component is useful for embedding serialized data within forms that can be submitted without displaying the content to the user.
 *
 * @param props - Includes the `value` that will be serialized and potentially other properties from `Input` component.
 */ function HiddenSerializedInput({ value }) {
    return /*#__PURE__*/ _jsx(Input, {
        hidden: true,
        value: JSON.stringify(value)
    });
}
/**
 * This `Form.item` wrapper allows you to render conditional visible fields with performance in mind.
 *
 * Example:
 *
 * ```ts
 * <FormItemHiddenSerialized
 *  name="my-awesome-filed"
 *  visible={isVisible}
 *  visibleFormProps={{ label: "My awesome label" }}
 * >
 *      <Select />
 * </FormItemHiddenSerialized>
 * ```
 */ function FormItemHiddenSerialized({ children, visible, visibleFormProps, name, ...props }) {
    return /*#__PURE__*/ _jsx(Form.Item, {
        name: name,
        ...visible ? {} : {
            noStyle: true
        },
        ...visible ? visibleFormProps : props,
        children: visible ? children : /*#__PURE__*/ _jsx(HiddenSerializedInput, {})
    });
}
export { FormItemHiddenSerialized };
